import { GetterTree } from "vuex";
import { TaxPricePeriodTranslationAdminzoneState } from "@/types/store/adminzone/tax_price_period_translation";
import { RootState } from "@/types/store/adminzone";
import { TaxPricePeriodTranslationData } from "@/types/tax_price_period_translation";

export const getters: GetterTree<TaxPricePeriodTranslationAdminzoneState, RootState> = {
  GET_TAX_PRICE_PERIOD_TRANSLATION: (state): Array<TaxPricePeriodTranslationData> => state.taxPricePeriodTranslation
}
